import { Box } from '@mui/material';
import { IContentOnTheLeftWrapper } from './interfaces';
import { useStyles } from './styles';

const ContentOnTheLeftWrapper = ({ children }: IContentOnTheLeftWrapper) => {
  const classes = useStyles();

  return (
    <Box sx={classes.outerwrapper}>
      <Box sx={classes.innerwrapper}>{children}</Box>
    </Box>
  );
};

export default ContentOnTheLeftWrapper;
